import { useTranslation } from '@mc/i18n'
import { useStaticData } from '@mc/static-data-react'
import { PricingText } from 'components/PricingText/PricingText'
import { CoursePageProps } from 'pages/classes/[slug]/types'
import { CM_TIMELINE_VIEW_I18N_NAMESPACE } from '../../i18n'
import { Subtitle } from './Subtitle'

export const SubtitlePricingCopy = () => {
  const { primaryGrowthCatAndSubcat } = useStaticData<{
    primaryGrowthCatAndSubcat: CoursePageProps['primaryGrowthCatAndSubcat']
  }>()
  const { t } = useTranslation(CM_TIMELINE_VIEW_I18N_NAMESPACE)

  return (
    <Subtitle>
      <span className='mc-mr-1'>
        {t('variant_1.whereWillMCTakeYou.subtitle', {
          primarySubcategory:
            primaryGrowthCatAndSubcat?.primarySubcategory?.name,
        })}
      </span>
      <PricingText translationKey='pen-5613_v1-cm-innovative-swing' />
    </Subtitle>
  )
}
